<template>
  <el-dialog
    :title="title"
    :visible.sync="$parent.renameStatus"
    class="rename-dialog"
    @submit.native.prevent="submit"
    @close="close"
    @open="open"
  >
    <el-form :rules="rules" :model="renameObj" ref="renameForm">
      <el-form-item prop="renameInput">
        <el-input
          placeholder="请输入名称"
          v-model="renameObj.renameInput"
          :maxlength="20"
          clearable
        />
      </el-form-item>
    </el-form>

    <span slot="footer" class="dialog-footer btn-wrap">
      <el-button type="default" @click="$parent.renameStatus = false" >
        取 消
      </el-button>
      <el-button type="primary" @click.stop="submit">确 定</el-button>
    </span>
  </el-dialog>
</template>

<script>
export default {
  props: {
    title: {
      type: String,
      default: "重命名",
    },
  },
  data() {
    return {
      renameObj: {
        renameInput: "",
      },
      rules: {
        renameInput: [
          { required: true, message: "请输入名称", trigger: "blur" },
        ],
      },
    };
  },
  watch: {
    "renameObj.renameInput": function (newVal) {
      this.renameObj.renameInput = newVal.replace(/\s*/g, "");
    },
  },
  methods: {
    open() {
      this.$nextTick(() => {
        this.$refs["renameForm"].resetFields();
        this.renameObj.renameInput = this.$parent.renameInput;
        // this.$refs["renameForm"].resetFields();
      });
    },
    submit(e) {
      this.buttonBlur(e);
      this.$refs["renameForm"].validate((valid) => {
        if (valid) {
          // this.$parent.submitRename();
          this.$emit("submit");
        }
      });
    },
    close() {
      this.renameObj.renameInput = "";
      this.$refs["renameForm"].resetFields();
    },
  },
};
</script>

<style></style>
